import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Page from '../../components/page';
import MechaStore from './store';
import TopMenu from '@src/business-components/top-menu';
import Link from '@src/components/link';
import MechaPoster from './components/mecha-poster';
import ArmedIntroduction from './components/armed-introduction';
import MoreMecha from './components/more-mecha';
import cx from 'classnames';
import CommonFooter from '@src/business-components/common-footer';

import toWebpImage from '@src/utils/to-webp-image';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import redirect from '@src/utils/redirect-if-mobile-accress';
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();
const lang = getLanguageByPath();
const styles = require('./index.less');

// 机甲详情  机甲立绘mecha-poster  武装介绍armed-introduction
const Mecha = () => {
  const store = useStore(() => {
    return new MechaStore();
  });

  // const { back_image } = store?.pageData;

  return (
    <Page className={cx(styles.MechaDetails, 'page-main')}>
      <div className={styles.bg} key={store.mechaId}>
        <TopMenu store={store.topMenuStore} />
        <Link
          className={styles.returnBtn}
          style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.Lang() + '/back.png'))})` }}
          onClick={() => {
            store.goBack();
          }}
        />
        <MechaPoster store={store.mechaPosterStore} />
        <ArmedIntroduction store={store.armedIntroductionStore} />
        <MoreMecha store={store.moreMechaStore} />
        <div className={styles.gotoTOPbg}>
          <Link
            className={styles.goTopBtn}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          />
        </div>
        {/* 底栏 */}
        <div className={styles.footerBox}>
          <CommonFooter store={store.CommonFooterStore} />
        </div>
      </div>
    </Page>
  );
};

export default observer(Mecha);
